import { render, staticRenderFns } from "./PdpFrOnly.vue?vue&type=template&id=2fadaafc&scoped=true"
import script from "./PdpFrOnly.vue?vue&type=script&lang=js"
export * from "./PdpFrOnly.vue?vue&type=script&lang=js"
import style0 from "./PdpFrOnly.vue?vue&type=style&index=0&id=2fadaafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadaafc",
  null
  
)

export default component.exports